import React from 'react'
import { Link } from 'react-router-dom'
import type { Location, LocationDescriptor } from 'history'
import { useGridRootProps } from '@mui/x-data-grid-pro'

interface DataGridToolbarAddButtonProps {
  children?: React.ReactNode | undefined
  to: LocationDescriptor<unknown> | ((location: Location<unknown>) => LocationDescriptor<unknown>)
}

declare module '@mui/x-data-grid-pro' {
  interface GridProSlotsComponent {
    AddButton: React.JSXElementConstructor<DataGridToolbarAddButtonProps>
  }

  interface GridSlotsComponentsProps {
    addButton?: DataGridToolbarAddButtonProps
  }
}

export function DataGridToolbarAddButton({ children, to }: DataGridToolbarAddButtonProps) {
  const rootProps = useGridRootProps()

  return (
    <rootProps.slots.baseButton color='primary' component={Link} role='button' size='small' to={to} variant='contained'>
      {children}
    </rootProps.slots.baseButton>
  )
}
